import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { supabase } from "../../client";

const Welcome = () => {
  const [userName, setuserName] = useState("");
  useEffect(() => {
    const fetch = async () => {
      const data = (
        await supabase
          .from("profiles")
          .select("name")
          .eq("id", supabase.auth.user().id)
      ).data;
      if (data[0]) setuserName(data[0].name);
      else setuserName(supabase.auth.user().email);
    };

    fetch();
  }, []);

  return (
    <Right>
      <Heading>WELCOME</Heading>
      <Heading>{userName}</Heading>
    </Right>
  );
};

const Right = styled.div`
  width: 75%;
  border: 1px solid #ddd;
  padding: 2em;
  form {
    display: flex;
    flex-direction: column;
  }
  input,
  button {
    padding: 1em;
    margin: 1em 0;
  }
  input {
    border: 1px solid #ddd;
  }
`;

const Heading = styled.div`
  color: #525252;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default Welcome;
